module.exports = __webpack_public_path__ + "img/precious02.10318a56.jpg";